import PaddingKeyboardAvoider from '@/features/ui/components/Modal/parts/KeyboardAvoider/parts/PaddingKeyboardAvoider'
import PositionKeyboardAvoider from '@/features/ui/components/Modal/parts/KeyboardAvoider/parts/PositionKeyboardAvoider'
import { FC, ReactNode } from 'react'

export type KeyboardAvoiderVariant = 'padding' | 'position'

interface KeyboardAvoiderProps {
    children: ReactNode
    variant?: KeyboardAvoiderVariant
    keyboardVerticalOffset?: number
}

const KeyboardAvoider: FC<KeyboardAvoiderProps> = ({
    children,
    variant = 'position',
    keyboardVerticalOffset,
}) => {
    return variant === 'padding' ? (
        <PaddingKeyboardAvoider keyboardVerticalOffset={keyboardVerticalOffset}>
            {children}
        </PaddingKeyboardAvoider>
    ) : (
        <PositionKeyboardAvoider keyboardVerticalOffset={keyboardVerticalOffset}>
            {children}
        </PositionKeyboardAvoider>
    )
}

export default KeyboardAvoider
